/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import {Notify,LoadingBar} from 'quasar'



export default { config: {"brand":{"primary":"#006699","secondary":"#007e71","accent":"#ba4682","dark":"#646363","dark-page":"#121212","positive":"#21BA45","negative":"#C10015","info":"#5485ab","warning":"#e18922"},"loadingBar":{"position":"top","color":"primary"}},plugins: {Notify,LoadingBar} }

